import React from "react";
import App from "./App";
import ReactDOM from "react-dom/client";
import "./index.css";
import { AuthProvider } from "./Context/AuthCheckContext";

import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
